import { render, staticRenderFns } from "./informList.vue?vue&type=template&id=106ccb1c&scoped=true&"
import script from "./informList.vue?vue&type=script&lang=js&"
export * from "./informList.vue?vue&type=script&lang=js&"
import style0 from "./informList.vue?vue&type=style&index=0&id=106ccb1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ccb1c",
  null
  
)

export default component.exports